import { Component, EventEmitter, Input, Output } from '@angular/core'
import { BaseFilter } from '../../models/BaseFilter'

@Component({
  standalone: false,
  selector: 'app-category-filter',
  templateUrl: './category-filter.component.html',
  styleUrls: ['./category-filter.component.scss'],
})
export class CategoryFilterComponent {
  get filter(): BaseFilter {
    return this._filter
  }

  @Input()
  set filter(value: BaseFilter) {
    this._filter = value
    if (this._filter && this._filter.hasSubfilters()) {
      this.subfiltersDisabled =
        this._filter.subfilters.every((sub) => sub.value) ||
        this._filter.subfilters.every((sub) => !sub.value)
      this.updateSubfilters()
    }
  }

  private _filter: BaseFilter
  @Output() onChange = new EventEmitter<any>()

  selectedSubfilter: BaseFilter = null
  subfiltersDisabled = false
  _showSubfilterHelp = false
  openTargetFiltersDropdown = false

  get selectedSubfilterTitle() {
    return (this.selectedSubfilter && this.selectedSubfilter.title) || ''
  }

  onFilterSelectValue(value, index: number = null) {
    const filter =
      index !== null ? this._filter.subfilters[index] : this._filter
    if (filter.multiple) {
      if (filter.isSelectedValue(value) && filter.value.length > 1) {
        if (Array.isArray(filter.value)) {
          filter.value.splice(filter.value.indexOf(value), 1)
        } else {
          return
        }
      } else if (filter.isSelectedValue(value) && filter.value.length === 1) {
        return
      } else {
        if (Array.isArray(filter.value)) {
          filter.value.push(value)
        } else {
          if (filter.value) {
            filter.value = [filter.value, value]
          } else {
            filter.value = value
          }
        }
      }
    } else {
      filter.value = value
    }
    if (!this._filter.multiple && index !== null) {
      this._filter.subfilters.forEach((item: any, idx: number) => {
        if (idx !== index) {
          item.value = undefined
        }
      })
    }

    this.onChange.emit(this._filter)
  }

  toggleHelp() {
    this._showSubfilterHelp = !this._showSubfilterHelp
  }

  getSubFilterHelp() {
    return this._filter.subfilters
      .find(
        (filter: BaseFilter) =>
          filter.key_name === this.selectedSubfilter.key_name,
      )
      .getValues()
  }

  toggleSubfilters() {
    this.subfiltersDisabled = !this.subfiltersDisabled
    this.updateSubfilters()
  }

  updateSubfilters() {
    if (this.subfiltersDisabled) {
      this._filter.subfilters.forEach((sub: BaseFilter) => {
        sub.value = undefined
      })
      this.selectedSubfilter = null
    } else {
      const selectedSubfilter =
        this._filter.subfilters.find((sub) => sub.value) ||
        this._filter.subfilters[0]
      if (!selectedSubfilter.value) {
        selectedSubfilter.value = selectedSubfilter.getFirstValue()
      }
      this.selectedSubfilter = { ...selectedSubfilter } as BaseFilter
    }
    this.onChange.emit(this._filter)
  }

  selectSubFilters(filter) {
    this._filter.subfilters.forEach((sub: BaseFilter) => {
      if (filter.title === sub.title) {
        sub.value = sub.getFirstValue()
      } else {
        sub.value = undefined
      }
    })

    this.selectedSubfilter = { ...filter } as BaseFilter
    this.onChange.emit(this._filter)
  }

  toggleTargetFiltersDropdown() {
    this.openTargetFiltersDropdown = !this.openTargetFiltersDropdown
  }

  hasHelp(help) {
    return (
      (typeof help === 'string' && help !== '') ||
      (typeof help === 'object' && help.title !== '')
    )
  }

  getSubfilters(filter) {
    return filter.subfilters.filter((s) => !s.hideTarget)
  }
}
